import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import Results from './Results/Results';
import SocialAssistanceSurveillance from './SocialAssistanceSurveillance/SocialAssistanceSurveillance';
import { HomeNav } from '../Common/Home/HomeNav';
import IgdFiltersProvider from './Common/Filters/contexts/IgdFiltersContext';
import Benefits from './Benefits/Benefits';
import CadUnique from './CadUnique/CadUnique';

function DashBoardIGD() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <IgdFiltersProvider>
                <ReactQueryDevtools initialIsOpen={false} />
                <div className="dashboards-page">
                    <HomeNav menus={menus} />
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="results" replace />}
                        />

                        <Route
                            path="/results/*"
                            element={
                                <Results
                                    dashboardPath={'dashboardigd'}
                                    menuPath={'results'}
                                />
                            }
                        />

                        <Route
                            path="/SocialAssistanceSurveillance/*"
                            element={
                                <SocialAssistanceSurveillance />
                            }
                        />

                        <Route
                            path="/Benefits/*"
                            element={
                                <Benefits />
                            }
                        />
                        
                        <Route
                            path="/cad-unique/*"
                            element={
                                <CadUnique />
                            }
                        />

                    </Routes>
                </div>
            </IgdFiltersProvider>
        </QueryClientProvider>
    );
}

export default DashBoardIGD;
